import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, ViewController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

@Component({
  selector: 'page-add-offer',
  templateUrl: 'addOffer.html',
  providers : [HttpClient, CustomToast]
})
export class AddOfferPage {

  viewCtrl: ViewController;

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  offer = {
    title : '',
    link : '',
    comments : ''
  };

  customToast : CustomToast;
  events : Events;
  filesToUpload: Array<File>;
  tags = '';
  response: any;

	constructor(viewCtrl: ViewController,public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
    this.viewCtrl = viewCtrl;
    this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.filesToUpload = [];
  }
  
  selectFile(fileInput: any){
    this.filesToUpload = <Array<File>> fileInput.target.files;
  }

  httpPostOffer(){
    this.httpClient.post('/offers',this.offer,(error,data)=>{
      if(!error){
        let response = data._body
        let jobOfferId = +(response.substring( 0, response.indexOf(",")).split('[')[1])
        if(this.filesToUpload.length>0){
          this.httpPostOfferPdf(jobOfferId)
        }else{
          this.customToast.showMessage('Oferta de trabajo creada correctamente',2000);
          this.navCtrl.pop();
          this.events.publish('addOffer:done');
        }
      }
    });
  }

  httpPostOfferPdf(jobOfferId:number){
    this.httpClient.upload('/pdfs',this.filesToUpload, this.tags, jobOfferId, (data: any)=>{
      this.customToast.showMessage('Oferta de trabajo creada correctamente',2000);
      this.navCtrl.pop();
      this.events.publish('addOffer:done');
    });
  }

  onClickSave(){
    this.httpPostOffer();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/offers/addOffer/addOffer.ts